import { HeroMesh } from '@/components/HeroMesh';
import { SiteLink } from '@/components/SiteLink';
import { ROUTES } from '@/constants/site';

function ArrowIcon() {
  return (
    <img
      src="/assets/icons/arrow-right-white.svg"
      alt=""
      aria-hidden="true"
      width="28"
      height="28"
      className="h-7 w-7"
    />
  );
}

export function HeroSection() {
  return (
    <section id="hero" aria-labelledby="hero-title" className="hero-viewport bg-ink-900">
      <HeroMesh variant="main" />

      <div className="inner relative z-10">
        <p className="mb-4">
          <img
            src="/assets/images/logo-nova-white.png"
            alt="Nova"
            width="2272"
            height="657"
            className="h-[30px] w-auto"
            fetchPriority="high"
          />
        </p>

        <h1 id="hero-title" className="heading-1 max-w-[900px] text-white">
          가장 어두운 순간,
          <br className="br-mobile" /> 가장 밝게 빛나는
        </h1>

        <p className="body-lead mt-20 max-w-[640px] text-white/75">
          Nova는 그 순간 가장 밝게 빛나는 별처럼,
          <br />
          골든타임 안에 위협을 탐지하고 분석하며 대응을 완결하는 AI 기반 DFIR 플랫폼입니다.
        </p>

        <div className="mt-[120px] flex flex-wrap gap-6">
          <SiteLink to={ROUTES.inquiry} className="btn-ghost-dark">
            도입문의 바로가기
            <ArrowIcon />
          </SiteLink>
          <SiteLink to={ROUTES.demo} className="btn-ghost-dark">
            플랫폼 체험해보기
            <ArrowIcon />
          </SiteLink>
        </div>
      </div>
    </section>
  );
}
